export const ABOUT_US = 'about_us'
export const ABOUT_US_EXTERNAL_PAGE_VERIFIED_REFURBISHED =
  'verified-refurbished'
